"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (number) {
  return number.toString();
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/meteor-paginated-graphql-react/lib/formatNumber.js
// module id = 640
// module chunks = 0